'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {
//   LinkIcon
// } from '../../components'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _IyvListTable = require('./IyvListTable.css');

var _IyvListTable2 = _interopRequireDefault(_IyvListTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListTdNetAssets = (_dec = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListTdNetAssets, _Component);

  //
  function IyvListTdNetAssets(props) {
    (0, _classCallCheck3.default)(this, IyvListTdNetAssets);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IyvListTdNetAssets.__proto__ || (0, _getPrototypeOf2.default)(IyvListTdNetAssets)).call(this, props));

    _this.state = {
      formattedVal: _format2.default.money(props.shareclass.fund_net_assets, true, props.shareclass.currency, true)
    };
    return _this;
  }
  //


  (0, _createClass3.default)(IyvListTdNetAssets, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'td',
        {
          styleName: 'col-right',
          onClick: this.props.mobile ? function () {} : this.props.clickShareclass(this.props.shareclass)
        },
        this.state.formattedVal
      );
    }
  }]);
  return IyvListTdNetAssets;
}(_react.Component), _class2.propTypes = {
  shareclass: _react.PropTypes.object.isRequired,
  clickShareclass: _react.PropTypes.func,
  mobile: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = IyvListTdNetAssets;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListTable/IyvListTdNetAssets.js
// module id = 1381
// module chunks = 0